<div *ngFor="let item of gerarArray(); index as i" class="c-passo"
  [ngClass]="{'c-passo--ativo': i === paginaAtiva - 1}">
</div>